import {Input} from "@/components/ui/input";
import {Button} from "@/components/ui/button";
import React, {useState} from "react";
import axios from "axios";
import {toast} from "react-hot-toast";
import API from "../constants/Api";
import {Loader2} from "lucide-react";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: ""
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let tempErrors = {};
        if (!formData.firstName.trim()) tempErrors.firstName = "First name is required";
        if (!formData.lastName.trim()) tempErrors.lastName = "Last name is required";
        if (!formData.email.trim()) tempErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) tempErrors.email = "Invalid email format";
        if (!formData.message.trim()) tempErrors.message = "Message is required";
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);

        setTimeout(async () => {
            try {
                await axios.post(API.SEND_EMAIL_URL, formData);
                toast.success("Message sent successfully!");
                setFormData({firstName: "", lastName: "", email: "", phone: "", message: ""});
                setErrors({});
            } catch (error) {
                toast.error("Failed to send message. Please try again.");
            } finally {
                setTimeout(() => setLoading(false), 500);
            }
        }, 500);
    };

    return (
        <>
            <div className="w-full space-y-8">
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-2 gap-4">
                        <div className={`col-span-2 md:col-span-1`}>
                            <label className="block text-sm font-medium text-white">First name</label>
                            <Input type="text" name="firstName" placeholder="First name" value={formData.firstName}
                                   onChange={handleChange}/>
                            {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}
                        </div>
                        <div className={`col-span-2 md:col-span-1`}>
                            <label className="block text-sm font-medium text-white">Last name</label>
                            <Input type="text" name="lastName" placeholder="Last name" value={formData.lastName}
                                   onChange={handleChange}/>
                            {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}
                        </div>
                        <div className={`col-span-2`}>
                            <label className="block text-sm font-medium text-white">Email</label>
                            <Input type="email" name="email" placeholder="Email" value={formData.email}
                                   onChange={handleChange}/>
                            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                        </div>
                        <div className={`col-span-2`}>
                            <label className="block text-sm font-medium text-white">Phone</label>
                            <Input type="text" name="phone" placeholder="Phone" value={formData.phone}
                                   onChange={handleChange}/>
                        </div>
                        <div className={`col-span-2`}>
                            <label className="block text-sm font-medium text-white">Message</label>
                            <textarea
                                className="w-full h-32 p-2 border border-gray-300 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                            />
                            {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
                        </div>
                    </div>
                    <Button type="submit" className="small-button white-variant mt-4">
                        Send
                    </Button>
                </form>
            </div>
            {/* Spinner Overlay */}
            <div id="spinner" className={loading ? `spinner-show` : `spinner-hide`}>
                <div className="spinner-content">
                    <Loader2 className="w-10 h-10 animate-spin text-white"/>
                    <p className="text-white">Sending message...</p>
                </div>
            </div>
        </>
    );
};

export default ContactForm;